<!--<div class="charts-container">
  <div *ngFor="let chartType of chartTypes" class="chart-container">
    <kendo-chart *ngIf="chartType !== 'pie'" [categoryAxis]="{ categories: categories }" [title]="{ text: title + ' ' + chartType }">
      <kendo-chart-series>
        <kendo-chart-series-item 
          *ngFor="let serie of seriesByType[chartType]"
          [data]="serie.data" 
          [stack]="serie.configuration.stack!=null ? serie.configuration.stack : false"
          [name]="serie.name"
          [type]="chartType"
          [color]="serie.color || getNextColor()">
        </kendo-chart-series-item>
      </kendo-chart-series>
    </kendo-chart>

    <kendo-chart *ngIf="chartType === 'pie'" [title]="{ text: title + ' ' + chartType }">
      <kendo-chart-series>
        <kendo-chart-series-item 
          *ngFor="let serie of seriesByType[chartType]"
          [data]="serie.data"
          [name]="serie.name"
          type="pie"
          [labels]="{
            visible: true,
            content: labelContent,
            position: 'outsideEnd',  
            line: { visible: true, length: 20 } 
          }"
          field="value"
          categoryField="category"
          colorField="color">
        </kendo-chart-series-item>
      </kendo-chart-series>
    </kendo-chart>
  </div>
</div>-->

<div class="charts-container">
  <div *ngFor="let chartType of chartTypes" class="chart-card">
    <!-- NON-PIE -->
    <kendo-chart *ngIf="chartType !== 'pie'"
                 [title]="{ text: title + ' ' + chartType }"
             [chartArea]="chartAreaOpts"
             [plotArea]="plotAreaOpts"
             [legend]="legendOpts"
             [seriesDefaults]="seriesDefaultsOpts"
             [tooltip]="tooltipOpts"
             [categoryAxis]="axisByType[chartType]">
      <kendo-chart-series>
        <kendo-chart-series-item
          *ngFor="let serie of seriesByType[chartType]"
          [data]="serie.data"
          [stack]="serie.configuration.stack != null ? serie.configuration.stack : false"
          [name]="serie.name"
          [type]="chartType"
          [color]="serie.color || getNextColor()">
        </kendo-chart-series-item>
      </kendo-chart-series>
      <kendo-chart-value-axis>
        <kendo-chart-value-axis-item
          [line]="{ visible: false }"
          [majorGridLines]="{ color: '#eee' }">
        </kendo-chart-value-axis-item>
      </kendo-chart-value-axis>
    </kendo-chart>

    <!-- PIE -->
    <kendo-chart *ngIf="chartType === 'pie'"
                 [title]="{ text: title + ' ' + chartType }"
             [legend]="{ position: 'right' }"
             [chartArea]="chartAreaOpts"
             [tooltip]="{ visible: true, format: '{0:n0}' }">
      <kendo-chart-series>
        <kendo-chart-series-item
          *ngFor="let serie of seriesByType[chartType]"
          [data]="serie.data"
          [name]="serie.name"
          type="pie"
          [labels]="{
            visible: true,
            content: labelContent,
            position: 'outsideEnd',
            line: { visible: true, length: 16 },
            background: 'transparent'
          }"
          field="value"
          categoryField="category"
          colorField="color">
        </kendo-chart-series-item>
      </kendo-chart-series>
    </kendo-chart>
  </div>
</div>
